export const periodsOverlap = (left, right) => left.from < right.to && left.to > right.from;

export const isValidExtraPeriod = (period, openingPeriods = [], otherExtraPeriods = []) => {
  if (!period?.from || !period?.to || period.from >= period.to) {
    return false;
  }

  if (openingPeriods.some((open) => periodsOverlap(period, open))) {
    return false;
  }

  return !otherExtraPeriods.some((other) => periodsOverlap(period, other));
};

const includeCurrentValue = (options, currentValue) => {
  if (!currentValue || options.some((option) => option.value === currentValue)) {
    return options;
  }

  return [...options, { value: currentValue, label: currentValue }]
    .sort((left, right) => left.value.localeCompare(right.value));
};

export const getExtraHoursStartOptions = (
  allOptions,
  period,
  openingPeriods = [],
  otherExtraPeriods = [],
) => {
  const options = allOptions.filter((option) => isValidExtraPeriod(
    { from: option.value, to: period.to },
    openingPeriods,
    otherExtraPeriods,
  ));
  return includeCurrentValue(options, period.from);
};

export const getExtraHoursEndOptions = (
  allOptions,
  period,
  openingPeriods = [],
  otherExtraPeriods = [],
) => {
  const options = allOptions.filter((option) => (
    option.value > period.from
    && isValidExtraPeriod(
      { from: period.from, to: option.value },
      openingPeriods,
      otherExtraPeriods,
    )
  ));
  return includeCurrentValue(options, period.to);
};
